export const DEVELOPMENT_DATA_ENDPOINT = 'https://satpersonal1.vanguard.com/api/laa-ret-etm-adobe-launch-webapp/data';
export const PRF_DATA_ENDPOINT = 'https://prfapps.ecs.rett.c1.vanguard.com/api/laa-ret-etm-adobe-launch-webapp/data';
export const TEST_DATA_ENDPOINT = 'https://satpersonal1.vanguard.com/api/laa-ret-etm-adobe-launch-webapp/data';
export const PRODUCTION_DATA_ENDPOINT = 'https://personal1.vanguard.com/api/laa-ret-etm-adobe-launch-webapp/data';
export const LOCAL_DATA_ENDPOINT = '/data';

export const ALL_ENDPOINTS = {
  DEVELOPMENT_DATA_ENDPOINT,
  LOCAL_DATA_ENDPOINT,
  PRF_DATA_ENDPOINT,
  PRODUCTION_DATA_ENDPOINT,
  TEST_DATA_ENDPOINT,
};
